import "common/page/page.js";
import "common/content-page/content-page.js";
import "common/page/footer/footer.js";
import "common/page/header/header.js";
import "common/page/navigation-panel/navigation-panel.js";

import "./common.scss";



// WEBPACK FOOTER //
// ./src/frontend/entry-points/common/common.js